import * as React from 'react';
import { Linked, useLinked } from '@type-r/react';
import { acceptInvoices, AcceptInvoicesData, InvoiceModel } from 'api/invoice';
import { Events } from '@type-r/models';
import { SocDialog } from './socDialog';
import { FormInput } from 'lqx-react/lib';
import { SocCompactInvoices, useSocCommonStyles } from './socCommon';

const filterDisputedUndisputed = (invoices: any[],): { disputed: any[], undisputed: any[] } => {
    return invoices.reduce((result, invoice) => {
       invoice.disputeStatus || invoice.isEscalatedInternally
       ? result.disputed.push(invoice)
       : result.undisputed.push(invoice);
     return result;
   }, {
     disputed: [],
     undisputed: []
   });
 }
 
export const PromiseToPayDialog = (props: {
    $isOpen: Linked<boolean>,
    invoices: InvoiceModel[],
}) => {
    const promiseToPayDate = useLinked(new Date());
    const filteredInvoices = filterDisputedUndisputed(props.invoices);

    let styles = useSocCommonStyles();

    const refreshTime = (input: Date): Date => {
        var result = new Date();
        result.setFullYear(input.getFullYear());
        result.setMonth(input.getMonth());
        result.setDate(input.getDate());
        return result;
    }

    const accept = async () => {
        let invoices = filteredInvoices.undisputed;
        if (!promiseToPayDate || !(invoices && invoices.length)) {
            return;
        }

        const date = refreshTime(promiseToPayDate.value);

        const promises: any[] = [];

        let invoicesToAccept = invoices.filter(i => !i.promiseToPayDateUtc).map(i => i.id);
        if (invoicesToAccept && invoicesToAccept.length) {
            const dataToAccept: AcceptInvoicesData = {
                acceptedInvoiceIds: invoicesToAccept,
                promiseToPayDate: date
            };
            promises.push(acceptInvoices(dataToAccept));
        }

        let invoicesToPatch = invoices.filter(i => i.promiseToPayDateUtc).map(i => i.id);
        if (invoicesToPatch && invoicesToPatch.length) {
            const dataToPatch: AcceptInvoicesData = {
                acceptedInvoiceIds: invoicesToPatch,
                promiseToPayDate: date
            };
            promises.push(acceptInvoices(dataToPatch, true));
        }

        await Promise.all(promises).catch(e => console.error(e));
    }

    return <SocDialog
        {...props}
        dialogType="promiseToPay"
        doIO={accept}
        onSuccess={() => Events.trigger("Soc:promiseToPayChanged")}
        isValid={() => !!filteredInvoices.undisputed.length}
        child={
            <>
                <FormInput date
                    className={styles.promiseToPayField}
                    label='Promise to Pay'
                    minDate={new Date()}
                    $value={promiseToPayDate}
                />
                {
                    filteredInvoices.undisputed.length ?
                        <SocCompactInvoices title={'Invoices to be updated'} invoices={filteredInvoices.undisputed}></SocCompactInvoices>
                        : <>
                            <br />
                            <p className={styles.missingUndisputed}>No valid invoices selected</p>
                        </>
                }
                {
                    filteredInvoices.disputed.length ?
                        <SocCompactInvoices title={'Below invoices are in Dispute state, hence updates are not being made to the invoices.'} invoices={filteredInvoices.disputed}></SocCompactInvoices>
                        : <></>
                }
            </>
        }
    />
}
